import { MANAGEMENT_TABS } from 'constants/navs'
import NavTabs from '../NavTabs'

const ManagementNav = () => <NavTabs tabs={MANAGEMENT_TABS} checkPermissions />

export default ManagementNav
